import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_EMPLOYEEWARNING,
  DELETE_EMPLOYEEWARNING,
  UPDATE_EMPLOYEEWARNING,
  ADD_NEW_EMPLOYEEWARNING,
} from "./actionType";

import {
  getEmployeeWarningSuccess,
  getEmployeeWarningFail,
  deleteEmployeeWarningSuccess,
  deleteEmployeeWarningFail,
  updateEmployeeWarningSuccess,
  updateEmployeeWarningFail,
  addEmployeeWarningSuccess,
  addEmployeeWarningFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveEmployeeWarningApi,
  getEmployeeWarningApi,
  updateEmployeeWarningApi,
  deleteEmployeeWarningApi,
  addNewEmployeeWarningApi
} from "../../helpers/backend_helper";

function* getEmployeeWarning({ payload: employeeWarning }) {
  try {
    const response = yield call(getEmployeeWarningApi, employeeWarning);
    yield put(getEmployeeWarningSuccess(GET_EMPLOYEEWARNING, response.data));
  } catch (error) {
    yield put(getEmployeeWarningFail(GET_EMPLOYEEWARNING, error));
  }
}

function* onUpdateEmployeeWarning({ payload: employeeWarning }) {
  try {
    if (employeeWarning.setApprove) {
      const response = yield call(approveEmployeeWarningApi, employeeWarning);
      yield put(updateEmployeeWarningSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateEmployeeWarningApi, employeeWarning);
      yield put(updateEmployeeWarningSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateEmployeeWarningFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteEmployeeWarning({ payload: employeeWarning }) {
  try {
    const response = yield call(deleteEmployeeWarningApi, employeeWarning);
    yield put(deleteEmployeeWarningSuccess({ employeeWarning, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteEmployeeWarningFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewEmployeeWarning({ payload: employeeWarning }) {
  try {
    const response = yield call(addNewEmployeeWarningApi, employeeWarning);
    yield put(addEmployeeWarningSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addEmployeeWarningFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetEmployeeWarning() {
  yield takeEvery(GET_EMPLOYEEWARNING, getEmployeeWarning);
}

export function* watchUpdateEmployeeWarning() {
  yield takeEvery(UPDATE_EMPLOYEEWARNING, onUpdateEmployeeWarning);
}

export function* watchDeleteEmployeeWarning() {
  yield takeEvery(DELETE_EMPLOYEEWARNING, onDeleteEmployeeWarning);
}

export function* watchAddNewEmployeeWarning() {
  yield takeEvery(ADD_NEW_EMPLOYEEWARNING, onAddNewEmployeeWarning);
}

function* employeeWarningSaga() {
  yield all([
    fork(watchGetEmployeeWarning),
    fork(watchDeleteEmployeeWarning),
    fork(watchUpdateEmployeeWarning),
    fork(watchAddNewEmployeeWarning)
  ]);
}

export default employeeWarningSaga;
